import { ScoreDial } from "@/components/iv/ScoreDial";
import { GeoMiniCards } from "@/components/iv/GeoMiniCards";
import { MathDialog } from "@/components/iv/MathDialog";
import { VERDICT_STYLES } from "@/constants/content";

export const VerdictPill = ({ evaluation }) => (
  <span
    className={`inline-flex w-fit items-center rounded-full border px-3 py-1 text-xs font-bold tracking-wide ${VERDICT_STYLES[evaluation?.verdict]?.pill ?? "border-white/10 text-slate-300"}`}
    data-testid="verdict-pill"
  >
    {evaluation?.verdict_label ?? "Loading verdict…"}
  </span>
);

const ScreenBody = ({ report }) => {
  const ev = report?.evaluation;
  return (
    <div className="space-y-3 p-3 sm:p-4" data-testid="laptop-screen-body">
      <div className="flex min-w-0 flex-wrap items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="truncate text-sm font-bold text-white" data-testid="laptop-case-title">
            {report?.idea?.case_study_meta?.flag} {report?.idea?.title ?? "Loading case study…"}
          </div>
          <div className="truncate text-[11px] text-slate-400">{report?.idea?.case_study_meta?.subtitle}</div>
        </div>
        <span className="rounded-full border border-white/10 px-2 py-0.5 text-[10px] text-slate-400">Reference case study</span>
      </div>
      <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center">
        <ScoreDial score={ev?.final_score} verdict={ev?.verdict} />
        <div className="flex min-w-0 flex-col items-center gap-2 text-center sm:items-start sm:text-left">
          <VerdictPill evaluation={ev} />
          {ev?.benchmark_label && <span className="text-[11px] font-medium text-cyan-300">{ev.benchmark_label}</span>}
          <p className="line-clamp-3 text-xs leading-relaxed text-slate-300" data-testid="laptop-headline-summary">{ev?.headline_summary}</p>
          <MathDialog report={report} />
        </div>
      </div>
      <GeoMiniCards geographies={report?.geographies} />
    </div>
  );
};

export const LaptopMockup = ({ report }) => (
  <figure className="w-full" data-testid="laptop-mockup" aria-label="Interactive report preview">
    <div className="rounded-t-2xl border border-white/10 bg-[#0B1021] p-1.5 shadow-[0_0_60px_rgba(37,99,235,0.18)]">
      <div className="flex items-center gap-1.5 border-b border-white/[0.06] px-2 py-1.5">
        <span className="h-2 w-2 rounded-full bg-rose-400/70" /><span className="h-2 w-2 rounded-full bg-amber-400/70" /><span className="h-2 w-2 rounded-full bg-emerald-400/70" />
        <span className="ml-2 min-w-0 truncate rounded-md bg-white/[0.04] px-2 py-0.5 font-mono text-[10px] text-slate-500">
          ideavalidator360.com/report/{report?.evaluation?.reference_slug ?? "…"}
        </span>
      </div>
      <div className="rounded-b-xl bg-gradient-to-b from-[#0B1021] to-[#060913]">
        <ScreenBody report={report} />
      </div>
    </div>
    <div className="mx-auto h-3 w-[104%] -translate-x-[2%] rounded-b-2xl bg-gradient-to-b from-slate-600/60 to-slate-800/80" aria-hidden="true" />
    <div className="mx-auto h-1 w-1/4 rounded-b-lg bg-slate-700/60" aria-hidden="true" />
  </figure>
);
